import React from "react";
import sanitize from "../util/sanitize";

const ProductDescription = React.memo(({ product }) => {
  return (
    <section className="pt-11">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Nav */}
            <div className="nav nav-tabs nav-overflow justify-content-start justify-content-md-center border-bottom">
              <a
                className="nav-link active"
                data-toggle="tab"
                href="#descriptionTab"
              >
                Description
              </a>

              {product?.howTo && (
                <a className="nav-link" data-toggle="tab" href="#howToTab">
                  How To Use
                </a>
              )}

              {product?.ingredients && (
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#ingredientsTab"
                >
                  Ingredients
                </a>
              )}

              <a
                className="nav-link"
                data-toggle="tab"
                href="#shippingReturnsTab"
              >
                Shipping &amp; Returns
              </a>
            </div>

            {/* Content */}
            <div className="tab-content">
              <div className="tab-pane fade show active" id="descriptionTab">
                <div className="row justify-content-center py-9">
                  <div
                    className="col-12 col-lg-10 col-xl-8"
                    dangerouslySetInnerHTML={{
                      __html: sanitize(product?.description),
                    }}
                  ></div>
                </div>
              </div>

              {product.howTo && (
                <div className="tab-pane fade" id="howToTab">
                  <div className="row justify-content-center py-9">
                    <div
                      className="col-12 col-lg-10 col-xl-8"
                      dangerouslySetInnerHTML={{
                        __html: sanitize(product?.howTo),
                      }}
                    ></div>
                  </div>
                </div>
              )}

              {product.ingredients && (
                <div className="tab-pane fade" id="ingredientsTab">
                  <div className="row justify-content-center py-9">
                    <div
                      className="col-12 col-lg-10 col-xl-8"
                      dangerouslySetInnerHTML={{
                        __html: sanitize(product?.ingredients),
                      }}
                    ></div>
                  </div>
                </div>
              )}

              <div className="tab-pane fade" id="shippingReturnsTab">
                <div className="row justify-content-center py-9">
                  <div className="col-12 col-lg-10 col-xl-8">
                    <p className="text-gray-500">
                      Products ship 5 - 10 business days from the date of
                      purchase. No returns or exchanges are allowed unless the
                      product was received damaged.{" "}
                      <a
                        className="text-body text-decoration-underline"
                        href="#!"
                      >
                        Find out more
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default ProductDescription;
